//why choose us中Fedex/ups shipping的icon

const FedexIcon = () => (
  <svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.1248 1.66667H22.2703L32.1248 11.4706V25H2.1248V1.66667Z"
      stroke="black"
      strokeWidth="3.33333"
    />
    <rect
      x="4.62447"
      y="27.4993"
      width="5"
      height="1.66667"
      fill="black"
      stroke="black"
      strokeWidth="1.66667"
    />
    <rect
      x="24.2078"
      y="27.0827"
      width="5.83333"
      height="2.5"
      fill="black"
      stroke="black"
      strokeWidth="0.833333"
    />
    <rect x="7.125" y="7.5" width="11.6667" height="3.33333" fill="#DA291C" />
  </svg>
)
export default FedexIcon
